import { Header } from 'semantic-ui-react';

export const MaintenanceDashboardHeader = () => (
  <div className="dashboard-header">
    <Header as="h2" className="ui header">
      Maintenance Dashboard
    </Header>
    <p>
      Asset problems requiring maintenance attention
    </p>
  </div>
);

export default MaintenanceDashboardHeader;